import React, { forwardRef } from "react";
import classNames from "classnames";
import "./searchoption.scss";
import Tooltip from "@mui/material/Tooltip";

const SearchOption = forwardRef(({ id, title, action, selected, disabled, icon }, ref) => {
  return (
    <>
      <Tooltip title={disabled ? "בקרוב!" : undefined}>
        <div
          ref={ref}
          data-tab-id={id}
          className={classNames("searchOption-wrapper", { selected, disabled })}
          onClick={disabled ? null : () => action(id)}
        >
          <label className="searchOption-title">
            {icon && <span className="searchOption-icon">{icon}</span>}
            {title}
          </label>
        </div>
      </Tooltip>
    </>
  );
});

export default SearchOption;
